// models/ReportTypeFavorites.js 
import { formatDisplayName, getIconClass, getIconLetter } from './ReportTypeDesignHelper';

export class ReportTypeFavorites {
  constructor(response = {}) {
    // Accept either:
    // - A bare array of favorites
    // - { data: { favorites: [...] } }
    // - { favorites: [...] }
    const favoritesArray = Array.isArray(response)
      ? response
      : Array.isArray(response?.data?.favorites)
        ? response.data.favorites
        : Array.isArray(response?.favorites)
          ? response.favorites
          : [];

    // Normalize favorites: ensure each item has required fields
    // Handle both camelCase (old) and snake_case (new) field names
    this.favorites = favoritesArray.map((item, index) => ({
      id: item.id || null,
      name: item.name,
      description: item.description || undefined,
      specialty: item.specialty || null,
      isEnterprise: !!(item.isEnterprise || item.is_enterprise),
      isEnterpriseEnabled: item.isEnterpriseEnabled !== undefined
        ? item.isEnterpriseEnabled
        : item.is_enterprise_enabled !== undefined
          ? item.is_enterprise_enabled
          : null,
      isPersonal: !!(item.isPersonal || item.is_personal),
      displayOrder:
        item.displayOrder !== undefined && item.displayOrder !== null
          ? item.displayOrder
          : item.display_order !== undefined && item.display_order !== null
            ? item.display_order
            : index
    }));
  }

  // Return only the favorite names in display order
  getFavorites() {
    return [...this.favorites]
      .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
      .map(f => f.name);
  }

  getIdForType(name) {
    return this.favorites.find(f => f.name === name)?.id;
  }

  isEnterprise(name) {
    return this.favorites.find(f => f.name === name)?.isEnterprise;
  }

  getDescription(name) {
    return this.favorites.find(f => f.name === name)?.description;
  }

  // Export a persistable representation (store full data array in order)
  toJSON() {
    return [...this.favorites]
      .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
  }

  // UI helpers proxied from shared helper
  static getIconClass(typeName) {
    return getIconClass(typeName);
  }

  static getIconLetter(typeName) {
    return getIconLetter(typeName);
  }

  static formatDisplayName(typeName) {
    return formatDisplayName(typeName);
  }
}